/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export const deepPurple = {
    50: '#EDEAFF',
    100: '#DCD6FF',
    200: '#CEC5FF',
    300: '#A697FB',
    400: '#8B7AF0',
    500: '#7B67EE',
    600: '#6653D1',
    700: '#5342B4',
    800: '#413297',
    900: '#312479',
    1000: '#160F3F',
};
